const ORDER_CONSTANTS = {
  processing: "Processing",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
  return: "Return",
  refund: "Refund",
};



export default ORDER_CONSTANTS;
